export default __webpack_public_path__ + "static/media/spark_44.f62b923c.png";